<template>
  <div>
    <!-- Content Row -->
    <b-row align="left" class="mt-5">
      <b-col md="8" class="mt-2">
        <p class="mb-1 font-weight-bold">
          <font class="h4 text-primary">Payment Instruction - {{product_location_array[order_location].brief_description}}</font>
        </p>
      </b-col>
      <b-col class="text-right">
        <b-row>
          <b-col>
                  <b-dropdown
                    text="Change Product Location"
                    variant="light"
                    toggle-class="bg-white border-secondary text-primary"
                  >
                    <b-dropdown-item v-for="(data,key) in product_location_array"
                        :key="data.id" @click="ChangeData(data.id,key)">
                      <span class="">{{data.product_name}}</span>
                    </b-dropdown-item>
                  </b-dropdown>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <br />
    <div class="text-left">
      <b-row class="mt-4">
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input
                v-model="filter"
                placeholder="Search"
              ></b-form-input>
              <b-input-group-append>
                <b-button
                  variant="primary"
                  :disabled="!filter"
                  @click="filter = ''"
                  >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select
              v-model="perPage"
              :options="pageOptions"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1"></b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>
          We're sorry, we're not able to retrieve this information at the
          moment, please try back later
        </p>
      </section>
      <!-- Main table element -->
      <b-table
        v-else
        responsive
        show-empty
        ref="pxContent"
        hover
        :items="items"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
        filter-debounce="500"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(display_name)="{ value }">
          <div>
            <label class="font-weight-bold text-primary">{{value}}</label>
          </div>
        </template>
        <template v-slot:cell(instructions)="{ value }">
          <div v-for="data in value" :key="data">
            <label v-if="data.name != ''">
            {{data.name}}
            </label>
            <label class="text-gray-400" v-else>
              (empty)
            </label>
          </div>
        </template>
        <template v-slot:cell(is_enable)="row">
          <div class="text-capitalize">
            <p
              class="text-success"
              v-if="row.value"
            >
              Enable
            </p>
            <p
              class="text-gray-400"
              v-else
            >
              Disabled
            </p>
          </div>
        </template>

        <template v-slot:cell(action)="{ value, item }">
          <!-- <router-link :to="{}" class="text-dark">
            <i class="fas fa-file-download mr-2"></i>
          </router-link>-->
          <router-link
            :to="{ name: 'editPaymentInstruction', params: { id: item.payment_method_id,product:item.product_location_id } }"
            class="text-primary"
            v-if="item.payment_method"
          >
            <img src="@/assets/ic-edit.svg" class="mr-2" alt />
          </router-link>
        </template>
      </b-table>

      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">Total entries {{ rows }}</b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      ref_number: "",
      awb_number: "",
      amount_min: "",
      amount_max: "",
      trensaction_status: "",
      payment_method: "",
      created_date_from: "",
      created_date_to: new Date(Date.now()),
      paid_date_from: "",
      paid_date_to: new Date(Date.now()),
      filterShow: false,
      loading: false,
      errored: false,
      tanggal: new Date().toJSON().slice(0, 10).replace(/-/g, "/"),
      fields: [
        {
          key: "display_name",
          label: "Payment Method",
          sortable: true,
          class: "text-left w-20",
        },
        {
          key: "instructions",
          label: "Instruction",
          sortable: true,
          class: "text-left",
        },
        {
          key: "is_enable",
          label: "Status",
          sortable: true,
          class: "text-center",
        },
        { key: "action", label: "Action", class: "text-center" },
      ],
      items: [],
      date_from: new Date(new Date().setDate(new Date().getDate() - 30)),
      date_to: new Date(Date.now()),
      name_export:
        "TransactionLog" +
        moment(new Date(Date.now())).format("YYYY-MM-DD") +
        ".csv",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: "",
      customerShow: false,
      loadingCSV: false,
      product_location_id: '',
      order_location: 0,
      CSV: [],
      product_location_array: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    rows() {
      return this.items.length;
    }
  },
  beforeCreate () {
    const formData = new FormData();
    formData.append("search_param", "");
    formData.append("limit", "1000");
    formData.append("page", "1");
    formData.append("sort_by", "");
    formData.append("is_sort_asc", true);
    this.$store
      .dispatch("PaymentMethodModule/getProductLocations", formData)
      .then((response) => {
        this.product_location_array = response.results;
        this.loading = false;
        formData.append("product_location_id", response.results[0].id);
        this.$store
        .dispatch("PaymentInstructionModule/getAllInstructions", formData)
        .then((response) => {
          this.items = response.results;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });

      })
      .catch((error) => {
        this.$swal({
          type: "error",
          title: "Oops...",
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
        this.loading = false;
      });
  },
  methods: {
    ChangeData(id,key){
      this.order_location = key;
      const formData = new FormData();
      formData.append("search_param", "");
      formData.append("limit", "1000");
      formData.append("page", "1");
      formData.append("sort_by", "");
      formData.append("is_sort_asc", true);
      formData.append("product_location_id", id);
      this.$store
        .dispatch("PaymentInstructionModule/getAllInstructions", formData)
        .then((response) => {
          this.items = response.results;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>

<style>
.w-15{
  width: 15%;
}
</style>
